import CloseIcon from '@mui/icons-material/Close';
import { Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import React from 'react';

const styles = {
    dialog: {
        borderRadius: '8px',
        maxWidth: '500px',
    },
    dialogTitle: {
        display: 'flex',
        borderBottom: '1px solid #0000001F',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '12px 16px!important',
    },
    dialogContent: {
        padding: '0 16px 0 24px',
        maxHeight: '40vh',
        marginTop: '24px',
        marginBottom: '24px',
        overflow: 'auto',
        '&::-webkit-scrollbar': {
            width: '8px',
        },
        '&::-webkit-scrollbar-track': {
            background: '#f1f1f1',
            borderRadius: '4px',
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#c1c1c1',
            borderRadius: '4px',
            '&:hover': {
                background: '#a8a8a8',
            },
        },
    },
    gridContainer: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: '12px',
    },
    makeItem: {
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        padding: '0 0',
    },
    makeName: {
        fontSize: '16px',
        fontWeight: 400,
    },
    closeIcon: {
        fill: '#000000DE',
        fontSize: 30,
    },
};

const VehicleMakesModal = ({ open, onClose, vehicleMakes = [] }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: styles.dialog,
            }}
        >
            <DialogTitle sx={styles.dialogTitle}>
                <Typography variant="h6" color={'#000000DE'}>
                    Vehicle Makes
                </Typography>
                <IconButton onClick={onClose} size="small">
                    <CloseIcon sx={styles.closeIcon} />
                </IconButton>
            </DialogTitle>

            <DialogContent sx={styles.dialogContent}>
                <div style={styles.gridContainer}>
                    {vehicleMakes.map((make, index) => (
                        <div key={`${make._id}-${index}`} style={styles.makeItem}>
                            {/* Checkmark icon */}
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                                <path
                                    d="M2.83203 9.5L5.83203 12.5L13.1654 4.5"
                                    stroke="#141B34"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>

                            {/* Make name */}
                            <span style={styles.makeName}>{make.name}</span>
                        </div>
                    ))}
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default React.memo(VehicleMakesModal);
